/**
 * Realm Ranks — DAoC-style endgame progression that unlocks AFTER level
 * cap (60). Ranks 1-14, each rank requires more realm-points (RP) than
 * the last (exponential). RP earned from PvP kills + objective captures
 * + warzone time. Ranks grant cosmetic titles + visual rank insignia,
 * NOT power. Power-affecting bonuses are forbidden by our no-P2W rule.
 */

export interface RealmRank {
  rank: number;
  rpRequired: number;
  /** Title shown next to character name. */
  title: { ru: string; en: string };
  /** Hex colour for the rank insignia + title text. */
  colour: string;
  /** Cosmetic unlock — cape pattern / banner trim id. */
  cosmeticUnlock: string;
}

const TITLES_RU = [
  '', 'Рекрут', 'Воин', 'Ветеран', 'Закалённый', 'Старший',
  'Командир', 'Капитан', 'Майор', 'Полковник', 'Генерал',
  'Лорд Войны', 'Маршал', 'Архистратиг', 'Несломлен',
];
const TITLES_EN = [
  '', 'Recruit', 'Warrior', 'Veteran', 'Hardened', 'Senior',
  'Commander', 'Captain', 'Major', 'Colonel', 'General',
  'Warlord', 'Marshal', 'Archstrategos', 'Unbroken',
];

const COLOURS = [
  '#9CA3AF', '#9CA3AF', '#9CA3AF', '#22C55E', '#22C55E',
  '#3B82F6', '#3B82F6', '#A855F7', '#A855F7', '#A855F7',
  '#F59E0B', '#F59E0B', '#F87171', '#F87171', '#FBBF24',
];

export const REALM_RANKS: RealmRank[] = Array.from({ length: 14 }, (_, i) => {
  const rank = i + 1;
  // RP curve: 200 × rank^2.6 (exponentially harder, last rank ~14 weeks of RvR)
  const rp = Math.floor(200 * Math.pow(rank, 2.6));
  return {
    rank,
    rpRequired: rp,
    title: { ru: TITLES_RU[rank] ?? `Ранг ${rank}`, en: TITLES_EN[rank] ?? `Rank ${rank}` },
    colour: COLOURS[rank] ?? '#9CA3AF',
    cosmeticUnlock: `rank-${rank}-trim`,
  };
});

export function rankFromRP(rp: number): RealmRank {
  let current = REALM_RANKS[0]!;
  for (const rank of REALM_RANKS) {
    if (rp >= rank.rpRequired) current = rank;
    else break;
  }
  return current;
}

export function nextRank(current: RealmRank): RealmRank | null {
  return REALM_RANKS[current.rank] ?? null;
}
